export default "__VITE_ASSET__CMtL0UxK__"